import parseDigits from './parseDigits';
var formatPostCode = function formatPostCode(string) {
  var digits = parseDigits(string.toString());
  var chars = digits.split('');
  return chars.reduce(function (r, v, index) {
    return index === 5 ? r + '-' + v : '' + r + v;
  }, '').substr(0, 10);
};
export default formatPostCode;